module.exports = __webpack_public_path__ + "static/media/projectPic12.0c8de13d.png";